import React, { useState, useEffect } from 'react'
import { compose } from 'redux'
import { Table, Paper } from '@material-ui/core'
import { Link as RouterLink } from 'react-router-dom'
import _ from 'underscore'

import THead from './TableHead'
import TBody from './TableBody'
import Search from './Search'
import TableTitle from './TableTitle'
import { withCategoriesData } from '../../hocs/withData'
import { withToggleSelectAll } from '../../hocs/withAction/withCategoryActions'
import { withTableAction } from '../../hocs/withAction/withTableAction'
import withSelected from '../../hocs/withData/withSelected'
import withTableBody from '../../hocs/withData/withTableBody'
import { Button } from '..'

const TableSortable = ({
  DeleteAllCheckboxAction,
  SelectCheckboxAction,
  Selected = {},
  FilterDataTable = () => {},
  DeleteCheckboxAction = () => {},
  data = [],
}) => {
  const [sortBy, setSortBy] = useState('categoryCode')
  const [sortDirection, setSortDirection] = useState(-1)
  const [disabled, setDisabled] = useState(true)
  const [searchValue, setSearchValue] = useState('')

  const handleOnSearch = e => {
    const { value } = e.currentTarget
    setSearchValue(value)
  }

  const dataList = () => {
    const isBigger = (a, b) => a > b

    const sortDataList = (a, b) =>
      isBigger(b.item[sortBy], a.item[sortBy]) ? sortDirection * 1 : sortDirection * -1
    return data.sort(sortDataList)
  }

  const onSelectAllToggle = (selectedAll = false) =>
    selectedAll
      ? data.map(n => SelectCheckboxAction(n.item, true)) && setDisabled(!disabled)
      : DeleteAllCheckboxAction() && setDisabled(!disabled)

  const handleToggleSortList = item => {
    const direction = item.key === sortBy ? -1 * sortDirection : 1

    setSortDirection(direction)
    setSortBy(item.key)
  }

  const handleOnRowSelected = (id, checked) =>
    checked ? SelectCheckboxAction(id, checked) : DeleteCheckboxAction(id)

  const filteredList = dataList()

  const onSelection = () => {
    const disable = _.isEmpty(Selected)
    return disable
  }

  useEffect(() => {
    FilterDataTable(searchValue)
  }, [searchValue])

  return (
    <>
      <div className="root">
        <div className="titleSection">
          <TableTitle title="Select Categories" />
          <Search onSearch={handleOnSearch} value={searchValue} />
        </div>
        <Paper className="paper">
          <Table stickyHeader className="table" size="small" aria-label="a dense table">
            <THead
              onSelectSortSelected={handleToggleSortList}
              onSelectAllToggle={onSelectAllToggle}
              sortBy={sortBy}
              direction={sortDirection === 1 ? 'asc' : 'desc'}
            />
            <TBody filteredList={filteredList} onRowSelected={handleOnRowSelected} />
          </Table>
        </Paper>
      </div>
      <div className="button-wrapper">
        <Button disabled={onSelection(Selected)} buttontext="Next">
          <RouterLink to="/modules">Next</RouterLink>
        </Button>
      </div>
    </>
  )
}

export default compose(
  withCategoriesData,
  withSelected,
  withToggleSelectAll,
  withTableAction,
  withTableBody
)(TableSortable)
